var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"fas fa-spinner d-inline-block spin",style:({ 'font-size': _vm.props.size }),attrs:{"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }